import "./GameFeatureCard.css";
import GameFeatureContent from "./GameFeatureContent";

const GameFeatureCard = ({
  badge,
  title,
  description,
  features = [],
  image,
  reverse = false,
  whatsappMessage
}) => {
  return (
    <section className={`game-feature-section ${reverse ? "reverse" : ""}`}>

      <div className="game-feature-wrapper">

        <div className="game-feature-image">
          <img
            src={image}
            alt={title}
          />
        </div>

        <GameFeatureContent
          badge={badge}
          title={title}
          description={description}
          features={features}
          whatsappMessage={whatsappMessage}
        />

      </div>

    </section>
  );
};

export default GameFeatureCard;